import { useState, useEffect, forwardRef, useImperativeHandle, useCallback } from "react";
import {NZLOGuidelines, 
  nonNZLOGuidelines,
  getGuidelinesFromStorage,
  setGuidelinesToStorage} from "../../../utilities/guideLineUtilities";
import {
  MessageContainer, ConnectChildNameContainer, ConnectChildName, ConnectChildImg, AddChildContainer,
  FarewellContainer, FarewellTitle, FarewellDesc, Multiplechildstyle, Multiplechildtextstyle, Templatestyle, Templateiconstyle, Templatetextstyle,
  MessageTopHeader, ChildMessageBody, LineSeparator, ImagePickerContainer, DeleteImageIcon,
  ImagePreviewContainer, ConnectPreviewButton, ConnectSaveButton, BibleVerseIcon, GalleryIcon, SensitiveArea, ConnectButtons,
  InstructionArea, TextWrapper, ToggleButton, ToggleText,
  WriteMsgCointainer,
  SensitiveWrapper, AutoSaveDraft,
  SensitiveAreaText,
  WritingTips,
  FAQ,
  ArrButton,
  TabsWrapperdiv, TemplateSelectedLanguageRadioButton, ChildMessageBodyFull, GalleryContainer,
  ArrButton2, SelectTemplateDiv, ChildSubject
} from "../../atoms/ConnectStories";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import * as Action from "@mywvglobal-shared/mywv-shared/action/persistItemsAction";
import * as GetTemplatesAction from "@mywvglobal-shared/mywv-shared/action/getWritingTemplatesAction";
import * as SponsorshipsAction from "@mywvglobal-shared/mywv-shared/action/sponsorshipsDataAction";
import * as SaveDraftAction from "@mywvglobal-shared/mywv-shared/action/saveDraftAction";
import * as ConnectAction from "@mywvglobal-shared/mywv-shared/action/connectAction";
import AddRecipientsComponent from "../../organism/addRecipientsModal";
import AttachPhotoWarningModalComponent from "../../organism/attachPhotoWarningModal";
import * as AppUtilities from "../../../utilities/appUtilities";
import AppConstants from "@mywvglobal-shared/mywv-shared/common/appConstants";
import TEMPLATEICON from "../../../images/templateicon.svg";
import SelectLanguage from "../../../images/select_language.svg";
import DELETEIMAGEICON from "../../../images/delete_image_icon.svg";
import BIBLEICON from "../../../images/bible_icon.svg";
import PLACEHOLDER from "../../../images/PlaceholderImage.png";
import GALLERYICON from "../../../images/photo_icon.svg";
import TemplateModal from "../templateModal";
import WriteAmessagePreview from "../writeAmessagePreview";
import RedIndicator from "../../../images/red-indicator.svg";
import faq from "../../../images/faq.svg";
import info from "../../../images/info_v1.svg";
import pencil from "../../../images/pencil.svg";
import WipeOutModalComponent from "../wipeOutModal";
import RemoveAttachmentModalComponent from "../removeAttachmentModal";
import useAlert from "../../../hooks/useAlert";
import DraftMessageModalComponent from "../draftMessageModal";
import BibleModal from "../../organism/bibleModal";
import { useNavigate, useParams } from "react-router-dom";
import { isMobile } from "../../../utilities/deviceUtilities";
import { encrypt, decrypt } from "../../../utilities/tokenizer";
import SENSITIVEAREAICON from "../../../images/red-indicator.svg";
import ArrowUP from "../../../images/double_arrows_up.svg";
import ArrowDown from "../../../images/double_arrows_down.svg";
import OrphanedIndicatorWhite from "../../../images/OrphanedIndicator_white.svg";
import { gaEvent } from "../../../utilities/analytics";
import FAQs from "./FAQs";
import TipsForWriting from "./TipsForWriting";
import SensitiveModalComponent from "../SensitiveModalComponent";
import { PageLoaderNew } from "../../atoms/Loader";
import CommonModalPopup from "../CommonModalPopup";
import { useRef } from "react";
import { writeMessageDateFormat } from "../../../utilities/dateUtilities";
import { Error, ErrorClose } from "../../atoms/Error";
import "../../../styles/ConnectScreen.css";
import { constants } from "../../../constants";
import { logoutUser } from "../../../utilities/LogOutUtils";
import * as LogoutAction from "@mywvglobal-shared/mywv-shared/action/persistItemsAction";
import useApiRepository from "../../../api/useApiRepository";
import moment from "moment";
import { getGenderMessage } from "../../../utilities/genderUtils";
import {validateMessageBody} from "../../../utilities/inputSanitizer"
import ConnectGuidelines from "../ConnectGuidelines";
import HideConnectModal from "./HideConnectModal";
const isWriteALetter= localStorage.getItem("isWriteALetter");
import DOMPurify from "dompurify";

const styles = {

  countStyle: {
    fontSize: "14px",
    fontFamily: "Lato",
    color: "rgba(102, 102, 102, 1)",
    alignSelf: "flex-start",
    paddingTop: "5px",
    paddingBottom: "8px",
  },
  countStyleRed: {
    color: "rgba(260, 68, 42, 1)"
  },
  sensitiveiconstyle: {
    right: "5%",
    width: "15px",
    height: "15px",
    position: "absolute",
    top: "-20%",
    border: "2px solid #fff",
    borderRadius: "50%",
    boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 3px 0px"
  },
}

const WriteAmessageView = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { setAlert, destroyAlert } = useAlert();
  const timerRef = useRef(null);
  const isMailSend = useRef(false);
  const messageDefaultValue = useRef("");
  const [lastUpdateon, setLastUpdateon] = useState("");
  const [addRecipinetModalVisible, setAddRecipinetModalVisible] = useState(false);
  const { worldReducer } = useSelector((state) => state);
  const childValues = worldReducer?.selectedChildValues ? worldReducer?.selectedChildValues : props?.childValues;
  const supporterGenderCode = worldReducer?.supporterGenderCode || "";
  const { loginReducer } = useSelector((state) => state);
  const { writingTemplatesReducer } = useSelector((state) => state);
  const [sponsoredChildList, setSponsoredChildList] = useState(null);
  const { sponsorshipsDataReducer } = useSelector((state) => state);
  const { persistItemsReducer } = useSelector((state) => state);
  const { draftDetailsReducer } = useSelector((state) => state);
  const [childFirstName, setChildFirstName] = useState(null);
  const [childImageURL, setChildImageURL] = useState(null);
  const [recipientsList, setRecipientsList] = useState(null);
  const [charecterLimit, setCharecterLimit] = useState(0);
  const [isSensitiveAreaVisible, setSensitiveAreaVisible] = useState(false);
  const [isBibleVerseVisible, setBibleVerseVisible] = useState(false);
  const [isConfigBibleVisible, setConfigBibleVisible] = useState(false);
  const [sensitiveText, setSensitiveText] = useState(false);
  const [templatesData, setTemplatesData] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [bibleData, setBibleData] = useState(null);
  const [isBibleModalVisible, setBibleModalVisibility] = useState(false);
  const [selectedBibleVerse, setSelectedBibleVerse] = useState(null);
  const [imagePickerResponse, setImagePickerResponse] = useState(null);
  const [imageBase64, setImageBase64] = useState(null);
  const [isEdited, setIsEdited] = useState(false);
  const [messageBody, setMessageBody] = useState("");
  const [messageBodyFixed, setMessageBodyFixed] = useState("");
  const [messageSubject, setMessageSubject] = useState(null);
  const [messageSubjectFixed, setMessageSubjectFixed] = useState(null);
  const [tempOcationData, setTempOcationData] = useState(null);
  const [isTemplateModalVisible, setTemplateModalVisible] = useState(isMobile(1199) ? false : true);
  const [isInstructionVisible, setIsInstructionVisible] = useState(isMobile(1199) ? false : true);
  const [isPreviewModalVisible, setPreviewModalVisible] = useState(false);
  const [isTemplateVisible, setTemplateVisible] = useState(false);
  const [attachPhotoWarningModalVisible, setAttachPhotoWarningModalVisible] = useState(false);
  const [removeAttachmentModalVisible, setRemoveAttachmentModalVisible] = useState(false);
  const [isAttachmentVisible, setAttachmentVisible] = useState(false);
  const [isWipeoutVisible, setIsWipeoutVisible] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [isSaveDraftPopupVisible, setSaveDraftPopupVisible] = useState(false);
  const [savedDraftList, setSavedDraftList] = useState(null);
  const [importMessage, setImportMessage] = useState(null);
  const [isImportDraftPopupVisible, setImportDraftPopupVisible] = useState(false);
  const [selectedDraft, setSelectedDraft] = useState(null);
  const [isDraftMessage, setIsDraftMessage] = useState(false);
  const [isMessageSubjectEdited, setIsMessageSubjectEdited] = useState(false);
  const [isMessageEdited, setIsMessageEdited] = useState(false);
  const [sensitiveAreaCTA, setSensitiveAreaCTA] = useState(t("Proceed"));
  const [showSensitiveAreaCheckbox, setShowSensitiveAreaCheckbox] = useState(t(true));
  const [minCharacterLimit, setMinCharacterLimit] = useState(0);
  const [isErrorOccured, setIsErrorOccured] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorTitle, setErrorTitle] = useState("");
  const [textFocus, settextFocus] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const [selectedChildData, setSelectedChildData] = useState();
  const [openFAQs, setOpenFAQs] = useState(false);
  const [openTips, setOpenTips] = useState(false);
  const [isSensitivePopupVisible, setIsSensitivePopupVisible] = useState(false);
  const { saveDraftReducer } = useSelector((state) => state);
  const [addRecepientsWarning, setAddRecepientWarning] = useState(false)
  const [showAutoSave, setShowAutoSave] = useState(false);
  const [silentDraftLoad, setSilentDraftLoad] = useState(false);
  const { connectFeedReducer } = useSelector((state) => state);
  const [firstRender, setFirstRender] = useState(true);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [languageWarning, setLanguageWarning] = useState(false);
  const [isPhotoGuideLineViewed, setIsPhotoGuideLineViewed] = useState(undefined);
  const {  connectReducer } = useSelector((state) => state);
  const [expanded, setExpanded] = useState(false);
  const[anniversaryNumber, setAnniversaryNumber] = useState("");
  const subjectCharLimit = loginReducer?.getSOConfiguration?.letterTemplateSettings?.subjectCharacterLimit;
  const apiRepo = useApiRepository();
  const showHideConnectModal = connectReducer?.showHideConnectModal;
  const ChildName = selectedChildData?.childFirstName;
  const genderCode = selectedChildData?.genderCode;
  const communityName = selectedChildData?.community;
  const eLetterDisableDate = selectedChildData?.eLetterDisableDate;
  
  const disableELetter = selectedChildData?.isCelebrationEligible && isDateEqualandAfter(eLetterDisableDate);
  const isSuccess = selectedChildData!==null && selectedChildData!==undefined;
  const nonPCChildrenList = sponsorshipsDataReducer?.getSponsorshipsData?.activeSponsorships?.filter((item) => !(item?.isCelebrationEligible  && isDateEqualandAfter(item?.eLetterDisableDate)));
  const shouldRenderGuidelines =
  !disableELetter &&
  isSuccess &&
  !isSensitivePopupVisible &&
  !isSaveDraftPopupVisible &&
  !isImportDraftPopupVisible &&
  !showHideConnectModal;
  const connectGuidelinesValues = persistItemsReducer?.selectedSOData?.soCode === "NZLO" ? NZLOGuidelines : nonNZLOGuidelines
  const [connectGuidelines, setConnectGuidelines] = useState([]);
  const donorID = persistItemsReducer?.sponsorID;
  const guidelineKey = donorID? `connect_guidelines_session_${donorID}`: null;
useEffect(() => {
  if (isSuccess && shouldRenderGuidelines) {
    setConnectGuidelines((prev) =>
      prev.map((item, index) =>
        index === 0 ? { ...item, isActive: true } : item,
      ),
    );
  }
}, [shouldRenderGuidelines]);

useEffect(() => {
  // Fetch guidelines from storage
  let storedGuidelines = getGuidelinesFromStorage(guidelineKey);

  if (!storedGuidelines && guidelineKey) {
    // Case 1: No guidelines found → initialize with defaults
    setGuidelinesToStorage(guidelineKey, connectGuidelinesValues);
    setConnectGuidelines(connectGuidelinesValues);
    return; // exit early
  }

  if (storedGuidelines.length > 0) {
    // Case 2: Guidelines exist → reset all items
    // First item active, rest inactive by default
    storedGuidelines = storedGuidelines.map((item, idx) => ({
      ...item,
      isActive: idx === 0,
      isBlinking: idx !== 0,
    }));

    // Special Case: Bible verse guideline should not be active for NZLO + sensitive child
    const isBibleVerseFirst =
      storedGuidelines[0]?.name === "add-bible-verse" &&
      persistItemsReducer?.selectedSOData?.soCode === "NZLO" &&
      isSensitiveAreaVisible;

    if (isBibleVerseFirst) {
      // Deactivate the first guideline
      storedGuidelines[0] = {
        ...storedGuidelines[0],
        isActive: false,
        isBlinking: true,
      };

      // Activate the next guideline if available
      if (storedGuidelines[1]) {
        storedGuidelines[1] = {
          ...storedGuidelines[1],
          isActive: true,
          isBlinking: false,
        };
      }
    }
  }

  // Persist updated guidelines back to storage and state
  setGuidelinesToStorage(guidelineKey, storedGuidelines);
  setConnectGuidelines(storedGuidelines);
}, [guidelineKey, connectGuidelinesValues, isSensitiveAreaVisible, persistItemsReducer]);

/** * Handler: Close a guideline by index
 * * Removes the guideline from the list and updates localStorage + state */
const onCloseGuideline = useCallback(
  (index) => {
    const updated = getGuidelinesFromStorage(guidelineKey);
    if (!updated) return;
    updated.splice(index, 1);
    // remove guideline at index
    setGuidelinesToStorage(guidelineKey, updated);
    setConnectGuidelines(updated);
  },
  [guidelineKey]
);
/**
 * Handler: View next guideline
 *
 * Removes the current guideline and activates the next one.
 * Special Case: If the current guideline is "attach-image" for NZLO + sensitive child,
 * skip one extra step (activate the second next guideline instead).
 */
const onViewNext = useCallback(
  (index, guideline) => {
    // Retrieve current guidelines from storage
    const updated = getGuidelinesFromStorage(guidelineKey);
    if (!updated) return;

    // Remove the current guideline at the given index
    updated.splice(index, 1);

    // Default step: move to the immediate next guideline
    let step = 1;

    // Special Case: Skip to the second next guideline
    const shouldSkipBibleVerse =
      guideline === "attach-image" &&
      persistItemsReducer?.selectedSOData?.soCode === "NZLO" &&
      isSensitiveAreaVisible;

    if (shouldSkipBibleVerse) {
      step = 2;
    }

    // Activate the next guideline if it exists
    const nextIndex = index; // after splice, next item is now at the same index
    const targetIndex = nextIndex + (step - 1);

    if (targetIndex < updated.length) {
      updated[targetIndex] = {
        ...updated[targetIndex],
        isActive: true,
        isBlinking: false,
      };
    }

    // Persist updated guidelines back to storage and state
    setGuidelinesToStorage(guidelineKey, updated);
    setConnectGuidelines(updated);
  },
  [guidelineKey, persistItemsReducer, isSensitiveAreaVisible]
);

  useEffect(()=> {
    if(isWriteALetter) {
      setTemplateModalVisible(true);
      setIsInstructionVisible(true);
    }
  },[isWriteALetter])
  useEffect(()=> {
    if(disableELetter) {
      dispatch(ConnectAction.showConnectReducer());
    }
  },[disableELetter]);
  


  // useEffect(() => {
  //   const baseURL = loginReducer?.getSOConfiguration?.soBaseUrl;
  //   const placeholders = loginReducer?.getSOConfiguration?.faqFormatter?.placeHolders;
  //   if (baseURL && placeholders) {
  //     apiRepo.getProjectCelebrationData(decrypt(params?.childcode));
  //   }
  // }, [loginReducer?.getSOConfiguration]);

const handleCloseConnectModal = () => {
  dispatch(ConnectAction.hideConnectReducer());
};
const handlePrimaryConnectModal = () => {
  handleCloseConnectModal();
  navigate(`/communityhomeview/${encrypt(selectedChildData?.childCode)}`);
};
      
useEffect(() => {
  const handle_videoFullScreen = () => {
    if (window?.screen?.orientation && window?.screen?.orientation?.type) {
      const savedMessage = persistItemsReducer?.savedMessageList || "";

      if (savedMessage && savedMessage.length > 0) {
        const trimmed = savedMessage.substr(0, charecterLimit);
        setMessageBody(trimmed);
      }
  
    }
  }
  window?.screen?.orientation?.addEventListener(
    "change",
    handle_videoFullScreen
  )
  return () => {
    window?.screen?.orientation?.removeEventListener(
      "change",
      handle_videoFullScreen
    )
  }
}, [window?.screen?.orientation?.type, persistItemsReducer?.savedMessageList])




  const title = {
    en: {
      HappyBirthday: "Happy Birthday",
      MerryChristmas: "Merry Christmas",
      HiText: "Hi",
      HiThere: "Hi there",
      HappyEaster: "Happy Easter",
      Farewell: "Farewell",
    },
  };

  useEffect(() => {
    setSensitiveAreaCTA(t("Proceed"));
  },)

  useEffect(() => {
    const apiResponse = connectFeedReducer?.getConnectFeed?.isPhotoGuideLineViewed;
    if (apiResponse !== undefined) {
      setIsPhotoGuideLineViewed(apiResponse);
    }
  }, [connectFeedReducer?.getConnectFeed?.isPhotoGuideLineViewed]);

  useEffect(() => {
    saveDraftReducer?.saveDraftResponse?.statusMessage === "SUCCESS" && props?.setDraftFeed(true);
    if (saveDraftReducer?.saveDraftResponse?.statusMessage === "SUCCESS" || saveDraftReducer?.errorMessage?.status) {
      dispatch(SaveDraftAction.hideSaveDraftReducer());
    }
  }, [saveDraftReducer?.saveDraftResponse]);

  useEffect(() => {
    if (localStorage.getItem("selectedLang") != null) {
      setSelectedLanguage(localStorage.getItem("selectedLang"));
      getWritingTemplates(getLanguageCode(localStorage.getItem("selectedLang")), true);
    } else {
      if (persistItemsReducer?.selectedSOData?.soCode === "AUTO" || persistItemsReducer?.selectedSOData?.soCode === "FINO") {
        setSelectedLanguage("English");
        getWritingTemplates(getLanguageCode("English"), true);
      }
    }
    if (sponsorshipsDataReducer?.getSponsorshipsData?.activeSponsorships) {
      let selectedChildValue = (sponsorshipsDataReducer?.getSponsorshipsData?.activeSponsorships?.filter((item) => { return item?.childCode == decrypt(params?.childcode) })[0]);
      setSelectedChildData(selectedChildValue)
    }

  }, [params, sponsorshipsDataReducer?.getSponsorshipsData]);

  useEffect(() => {
    if ((isFarewell && !eLetterDisableDate) || isDateEqualandAfter(eLetterDisableDate)) {
      setMessageBody("")
      setMessageBodyFixed("")
      return
    }
    if ((messageBody && messageBodyFixed && messageBody != messageBodyFixed)
      || isEdited) {
      if (isMailSend.current === false) {
        let debouncedCall = debounce(onSaveDraftClick, 30000);
        debouncedCall();
      }
    }
  }, [isMailSend.current, isEdited, messageBody, messageBodyFixed, messageSubjectFixed])

  useEffect(() => {
    if (connectFeedReducer?.getConnectFeed?.draftDetails && connectFeedReducer?.getConnectFeed?.draftDetails?.letterWritingLanguageCode) {
      setSelectedLanguage(
        getLanguageCode(
          connectFeedReducer?.getConnectFeed?.draftDetails?.letterWritingLanguageCode,
          true
        )
      );
      getWritingTemplates(connectFeedReducer?.getConnectFeed?.draftDetails?.letterWritingLanguageCode, true);
    }
  }, [connectFeedReducer && firstRender]);

  const setConfigBasedValues = () => {
    const letterTemplateValues = loginReducer?.getSOConfiguration?.letterTemplateSettings;
    if (letterTemplateValues && letterTemplateValues?.occasions) {
      setTemplateVisible(true);
    }
    if (letterTemplateValues && letterTemplateValues?.bibleVerse) {
      setConfigBibleVisible(true);
      setBibleVerseVisible(true);
    }
    if (letterTemplateValues && letterTemplateValues?.characterLimit) {
      setCharecterLimit(letterTemplateValues?.characterLimit);
      setMinCharacterLimit(letterTemplateValues?.minCharacterLimit);
    }
  };

  const updatePhotoGudielineViewedState = async () => {
    await apiRepo.connectRepository.updatePhotoGuidelineViewedStatus();
  };

  const getWritingTemplates = async (code, isLanguageChange = false) => {
    // dispatch action in redux call
    apiRepo.connectRepository.getWritingTemplates(code, isLanguageChange);
  };

  const getSponsorshipsDataFromServer = async () => {
    dispatch(SponsorshipsAction.clearSponsorshipsDataReducer());
    dispatch(GetTemplatesAction.showWritingTemplatesReducer());
    dispatch(GetTemplatesAction.hideWritingTemplatesReducer());
    const network = window.navigator.onLine;
    if (network) {
      apiRepo.connectRepository.getSponsorshipsData();
    } else {
      setErrorMessage(t("NoInternet"));
      setIsErrorOccured(true);
    }
  };

  const setSensitiveAreaText = (reciepients) => {
    const letterTemplateValues = loginReducer?.getSOConfiguration?.letterTemplateSettings;
    if (letterTemplateValues && letterTemplateValues?.sensitiveAPDefaultText) {
      if (persistItemsReducer?.selectedSOData?.soLanguageCultureCode === AppConstants.FR_FR) {
        setSensitiveText(letterTemplateValues?.sensitiveAPDefaultText?.replace("{0}", t("filleul")));
        if (reciepients
          && reciepients.length == 1
          && AppUtilities.isGenderFemaleOrGirl(reciepients[0].genderCode)) {
          setSensitiveText(letterTemplateValues?.sensitiveAPDefaultText?.replace("{0}", t("filleule")));
        }
      } else {
        setSensitiveText(letterTemplateValues?.sensitiveAPDefaultText);
      }
    }
  };

  const setRecipientsListValues = () => {
    const childValues = props.childValues;
    if (childValues && sponsoredChildList && sponsoredChildList.length > 0) {
      const objIndex = sponsoredChildList
        .findIndex((obj) => obj.childCode == childValues.childCode);
      if (objIndex > -1) {
        sponsoredChildList[objIndex].isSelected = true;
        setChildFirstName(sponsoredChildList[objIndex]?.childFirstName);
        setChildImageURL(sponsoredChildList[objIndex]?.childImageURL);
        setRecipientsList([sponsoredChildList[objIndex]]);
        setMessageTitle(1, null, sponsoredChildList[objIndex]?.childFirstName, sponsoredChildList);
        if (sponsoredChildList[objIndex].sensitivity == 1
          || sponsoredChildList[objIndex].sensitivity == 2) {
          setSensitiveAreaVisible(true);
          setBibleVerseVisible(false);
        } else {
          setSensitiveAreaVisible(false);

        }
        setSensitiveAreaText([sponsoredChildList[objIndex]]);
      }
    }
  };

  const getLanguageCode = (name, reverse = false) => {
    let languageList =
      loginReducer?.getSOConfiguration?.connectScreenLanguageOptions
        ?.supportedLanguages || [];
    if (reverse) {
      languageList = languageList.find((item) => item.languageCode === name);
      return languageList ? languageList.languageName : "";
    }
    languageList = languageList.find((item) => item.languageName === name);
    return languageList ? languageList.languageCode : "";
  };

  const saveDraft = async() => {
    if ((isFarewell && !eLetterDisableDate) || isDateEqualandAfter(eLetterDisableDate)) {
      return
    }
    const childCode = recipientsList?.map((r) => r.childCode);
    const letterWritingLanguageCode = loginReducer?.getSOConfiguration?.connectScreenLanguageOptions?.supportedLanguages
      ? getLanguageCode(selectedLanguage) : "";
    const draftData = {
      subject: messageSubject,
      messageBody: messageBody,
      childCode: childCode,
      occationCode: selectedTemplate?.artifactID,
      bibleVerseCode: selectedBibleVerse?.artifactID,
      imageBase64: imageBase64,
      letterWritingLanguageCode: letterWritingLanguageCode,
    };

    await apiRepo.connectRepository.saveDraft(draftData);

    messageDefaultValue.current = messageBody;
    setLastUpdateon(new Date());
  };

  const onSaveDraftClick = () => {
    if (recipientsList && recipientsList?.length < 1) {
      if (messageBody && messageBody !== "") {
        isSaveDraftPopupVisible && setSaveDraftPopupVisible(false);
        setAddRecepientWarning(true);
      }
      return;
    }
    if (
      loginReducer?.getSOConfiguration?.connectScreenLanguageOptions
        ?.multipleLanguagesSupported &&
      selectedLanguage.trim().length === 0
    ) {
      setLanguageWarning(true);
      return;
    }
    if (messageBody && messageBody !== "") {
      // new code for language - end
      setSaveDraftPopupVisible(false);
      // Sanitize messageBody before saving draft
      setMessageBody(messageBody);
      saveDraft();
      setIsEdited(false);
      setShowAutoSave(true)
    }
  };

  const onDiscardClick = () => {
    setSaveDraftPopupVisible(false);
    navigate(`/communityhomeview/${encrypt(selectedChildData?.childCode)}`)
  };

  const checkSaveDraftAvailable = () => {
    if (isEdited) {
      setSaveDraftPopupVisible(true);
    } else {
      navigate(-1);
    }
  };

  useImperativeHandle(ref, () => ({
    getAlert() {
      checkSaveDraftAvailable();
    },
    PopulateDraftData() {
      PopulateDraftData();
    }
  }));

  useEffect(() => {
    if(loginReducer?.isSOConfigurationLoaded) {
      setConfigBasedValues();
      getWritingTemplates(loginReducer);
      getSponsorshipsDataFromServer();
    }
  }, [loginReducer?.isSOConfigurationLoaded]);

  useEffect(() => {
    if (sponsoredChildList && sponsoredChildList.length > 0) {
      setRecipientsListValues();
    }
  }, [sponsoredChildList]);

  function calculateAnniversaryYears(today, sponsorshipStartDate) {
    const oneYearInMilliseconds = 31536000000;
    const timeDiff = today.getTime() - sponsorshipStartDate.getTime();
    let yearsInMilliseconds = Math.floor(timeDiff / oneYearInMilliseconds);
    if (today < new Date(sponsorshipStartDate.getFullYear() + yearsInMilliseconds, sponsorshipStartDate.getMonth(), sponsorshipStartDate.getDate())) {
      yearsInMilliseconds--;
    }
    return yearsInMilliseconds;
  }

  useEffect(() => {
    if (writingTemplatesReducer?.getWritingTemplates) {
      setBibleData(writingTemplatesReducer?.getWritingTemplates?.bibleVerses);
    }
  }, [writingTemplatesReducer?.getWritingTemplates]);

  useEffect(() => {
    let _copyOccasion = writingTemplatesReducer?.getWritingTemplates?.occasions;
    if (_copyOccasion) {
      const updatedOccasions = _copyOccasion.map((ele) => {
        if (ele.artifactCode === "OCN_ANNIVERSARY") {
          let anniversaryNumber = 0;
          if (selectedChildData && selectedChildData.sponsorshipStartDate) {
            const today = new Date();
            const sponsorshipStartDate = new Date(selectedChildData.sponsorshipStartDate);  //09/10/2024 12:00:00 AM
            anniversaryNumber = calculateAnniversaryYears(today, sponsorshipStartDate);
            setAnniversaryNumber(anniversaryNumber)
            if(anniversaryNumber == "1"){
              const updatedBody = ele.body
              .replace("<SponsorshipYears>", "a")
              .replace("years", "year")
            return { ...ele, body: updatedBody };
            }else{
            const updatedBody = ele.body
              .replace("<SponsorshipYears>", anniversaryNumber?.toString());
            return { ...ele, body: updatedBody };
            }
          }
        }
        return ele;
      });
      setTemplatesData(updatedOccasions);
     
    }
  }, [writingTemplatesReducer?.getWritingTemplates, childFirstName])

  useEffect(() => {
    if (sponsorshipsDataReducer?.getSponsorshipsData) {
      setSponsoredChildList(sponsorshipsDataReducer?.getSponsorshipsData?.activeSponsorships);
    }
  }, [sponsorshipsDataReducer?.getSponsorshipsData]);

  useEffect(() => {
    if (templatesData && templatesData.length > 0 && selectedChildData && selectedChildData != "") {
      templatesData[0].isSelected = true;
      if (selectedTemplate) {
        addTemplateHandler(
          templatesData.find(
            (ele) => ele.artifactCode === selectedTemplate.artifactCode
          )
        );
      } else if (localStorage.getItem("fromanniversary") === "YES") {
        addTemplateHandler(
          templatesData.find(
            (ele) => ele.artifactCode === "OCN_ANNIVERSARY"
          )
        )
        localStorage.removeItem("fromanniversary");
      }
    }
  }, [templatesData]);

  useEffect(() => {
    isErrorOccured && setAlert(errorTitle, errorMessage, "", "", "error", false, false, false, setIsErrorOccured(false));
    setTimeout(() => { setIsErrorOccured(false); destroyAlert(); }, 3000);
  }, [isErrorOccured, setIsErrorOccured])

  const setMessageTitle = (childCount, template, displayname) => {
    let isMultipleChildSelected = true;
    let childName = "";
    let message = "";
    if (childCount == 1) {
      isMultipleChildSelected = false;
      childName = displayname;
    }else if(childCount > 1){
      childName = "<sponsored child’s name>";
    }
    if (template && template.artifactCode && template.artifactCode == "OCN_BIRTHDAY") {
      if (isMultipleChildSelected) {
       if (selectedLanguage === "English") {
          message = `${title?.en.HappyBirthday} ${childName}!`;
        }
        else {
          message = `${t("HappyBirthday")} ${childName}!`;
        }
      } else {
        if (selectedLanguage === "English") {
          message = `${title?.en.HappyBirthday} ${childName}!`
        }
        else {
          message = `${t("HappyBirthday")} ${childName}!`;
        }
      }
    } else if (template && template.artifactCode && template.artifactCode == "OCN_CHRISTMAS") {
      if (isMultipleChildSelected) {
        if (selectedLanguage === "English") {
          message = `${title?.en.MerryChristmas} ${childName}!`;
        }
        else {
          message = `${t("MerryChristmas")} ${childName}!`;
        }
      } else {
        if (selectedLanguage === "English") {
          message = `${title?.en.MerryChristmas} ${childName}!`
        }
        else {
          message = `${t("MerryChristmas")} ${childName}!`;
        }
      }
    } else if (template && template.artifactCode && template.artifactCode == "OCN_FAREWELL") {
      if (isMultipleChildSelected) {
        if (selectedLanguage === "English") {
          message = `${title?.en.Farewell} ${childName}!`;
        }
        else {
          message = `${t("Farewell")} ${childName}!`;
        }
      } else {
        if (selectedLanguage === "English") {
          message = `${title?.en.Farewell} ${childName}!`
        }
        else {
          message = `${t("Farewell")} ${childName}!`;
        }
      }
    } else if (template && template.artifactCode && template.artifactCode == "OCN_EASTER") {
      if (isMultipleChildSelected) {
        if (selectedLanguage === "English") {
          message = `${title?.en.HappyEaster} ${childName}!`;
        }
        else {
          message = `${t("HappyEaster")} ${childName}!!`;
        }
      } else {
        if (selectedLanguage === "English") {
          message = `${title?.en.HappyEaster} ${childName}!`
        }
        else {
          message = `${t("HappyEaster")} ${childName}!`;
        }
      }
    } else if (isMultipleChildSelected) {
      if (selectedLanguage === "English") {
        //message = `${title?.en.HiThere}!`
        message = `${title?.en.HiText} ${childName}!`
      }
      else {
        message = `${t("HiText")} ${childName}!`;
      }
    } else {
      if (selectedLanguage === "English") {
        message = `${title?.en.HiText} ${childName}!`
      }
      else {
        message = `${t("HiText")} ${childName}!`;
      }
    }
    setMessageSubject(message);
    setMessageSubjectFixed(message);
  };

   const handleSubjectChange = (e) =>{
        setMessageSubject(e.target.value);
        if (e.target.value) {
          if (!isMessageSubjectEdited) {
            setIsMessageSubjectEdited(true);
          }
            setIsEdited(true);
          } else {
            setIsEdited(false);
          }
     }

  //start code auto save draft
  function debounce(func, wait = 1000) {
    return (...args) => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        setSilentDraftLoad(true);
        func.call(this, args);
        if (messageBody === "") {
          setShowAutoSave(false);
        } else {
          setShowAutoSave(true);
        }
        setTimeout(() => {
          setSilentDraftLoad(false);
        }, 3000);
      }, wait);
    };
  }

  const handleMessageChange = (e, whichRef) => {
    let updatedValue = e.target.value.substr(0, charecterLimit);

    // Only update state and dispatch if content has changed
    if (updatedValue !== messageBodyFixed || updatedValue !== messageBody) {
      setMessageBody(updatedValue);
      const param = {
        savedMessageList: updatedValue,
      };
      dispatch(Action.saveMessagePersist(param));
    }

    setMessageBody(updatedValue);
    if (whichRef && whichRef.current) {
      whichRef.current.style.height = "auto";
      whichRef.current.style.height = whichRef.current.scrollHeight + "px";
    }
    if (e.target.value) {
      if (!isMessageEdited) {
        setIsMessageEdited(true);
      }
      setIsEdited(true);
    } else {
      setIsEdited(false);
    }
  };

  const textareaRefSensitive = useRef(null);
  const textareaRefFull = useRef(null);

  // Auto-resize on mount/update for both refs
  useEffect(() => {
    if (isSensitiveAreaVisible && textareaRefSensitive.current) {
      textareaRefSensitive.current.style.height = "auto";
      textareaRefSensitive.current.style.height = textareaRefSensitive.current.scrollHeight + "px";
    } else if (!isSensitiveAreaVisible && textareaRefFull.current) {
      textareaRefFull.current.style.height = "auto";
      textareaRefFull.current.style.height = textareaRefFull.current.scrollHeight + "px";
    }
  }, [isSensitiveAreaVisible, messageBody]);

  const formattedTemplateText = (occationCode, occationBody) => {
    if (occationBody) {
      let occationmessage = occationBody;
      let isSponsorMale = true;
      let isChildBoy = true;
      if (supporterGenderCode && AppUtilities.isGenderFemaleOrGirl(supporterGenderCode)) {
        isSponsorMale = false;
      }
      if (recipientsList
        && recipientsList.length == 1
        && AppUtilities.isGenderFemaleOrGirl(recipientsList[0].genderCode)) {
        isChildBoy = false;
      }
      if (occationCode && occationCode == "OCN_GENERAL") {
        occationmessage = occationmessage.replace("{0}", isSponsorMale ? t("fier") : t("fière"));
        occationmessage = occationmessage.replace("{1}", isSponsorMale ? t("tonparrain") : t("tamarraine"));
      } else if (occationCode && occationCode == "OCN_BIRTHDAY") {
        occationmessage = occationmessage.replace("{0}", isChildBoy ? t("entoure") : t("entouree"));
        occationmessage = occationmessage.replace("{1}", isChildBoy ? t("aime") : t("aimee"));
        occationmessage = occationmessage.replace("{2}", isChildBoy ? t("entoure") : t("entouree"));
        occationmessage = occationmessage.replace("{3}", isSponsorMale ? t("fier") : t("fière"));
        occationmessage = occationmessage.replace("{4}", isSponsorMale ? t("tonparrain") : t("tamarraine"));
      } else if (occationCode && occationCode == "OCN_FAREWELL") {
        occationmessage = occationmessage.replace("{0}", isSponsorMale ? t("tonparrain").toLowerCase() : t("tamarraine").toLowerCase());
        occationmessage = occationmessage.replace("{1}", isSponsorMale ? t("ravi") : t("ravie"));
        occationmessage = occationmessage.replace("{2}", isSponsorMale ? t("fier") : t("fière"));
      } else if (occationCode && occationCode == "OCN_EDUCATION") {
        occationmessage = occationmessage.replace("{0}", isSponsorMale ? t("sur") : t("sure"));
        occationmessage = occationmessage.replace("{1}", isSponsorMale ? t("tonparrain") : t("tamarraine"));
      } else {
        occationmessage = occationmessage.replace("{0}", isSponsorMale ? t("tonparrain") : t("tamarraine"));
      }
      return occationmessage;
    }
    return null;
  };

  useEffect(() => {
    const draftDetail = []
    if (connectFeedReducer?.isServiceSuccess && connectFeedReducer?.getConnectFeed?.draftDetails != null) {
      draftDetail.push(connectFeedReducer?.getConnectFeed?.draftDetails)
      setSavedDraftList(draftDetail);
    }
  }, [connectFeedReducer?.isServiceSuccess]);

  function getCookie(name) {
    var re = new RegExp(name + "=([^;]+)");
    var value = re.exec(document.cookie);
    return (value != null) ? unescape(value[1]) : null;
  }

  // Do not show the sensitive popup if the import draft popup is already visible.
  // This prevents two modals from showing at the same time on load.
  // The sensitive popup will be triggered after the draft popup is closed.
  useEffect(() => {
    if (isSensitiveAreaVisible && !isImportDraftPopupVisible && (getCookie(persistItemsReducer?.sponsorID) == null || getCookie(persistItemsReducer?.sponsorID) != "DisableSensitive")) {
      setIsSensitivePopupVisible(true)
    }
  }, [isSensitiveAreaVisible, isImportDraftPopupVisible]);

  /// Check if any draft is available for import
  /// If available, show the import draft popup
  useEffect(() => {
    const childList = sponsorshipsDataReducer?.getSponsorshipsData?.activeSponsorships;
    if (savedDraftList) {
      const sponsorID = persistItemsReducer?.sponsorID;
      const draft = savedDraftList.find((obj) => (obj.donorID == sponsorID));
      if (draft) {
        setSelectedDraft(draft);
        if (draft.childCode && draft.childCode.length > 0
          && childList && childList.length > 0) {
          const recipients = childList
            .filter((item) => draft.childCode.includes(item.childCode));
          if (recipients && recipients.length > 0 && recipients?.filter((item) => item?.childCode == decrypt(params?.childcode))?.length > 0) {
            let childinfo;
            if (draft?.childCode?.length > 1) {
              childinfo = `${recipients?.filter((item) => item?.childCode == decrypt(params?.childcode))[0]?.childFirstName} + ${draft?.childCode?.length - 1}`;
            } else {
              childinfo = recipients[0].childFirstName;
            }
            setImportMessage(t("ImportMessageDescription", { childinfo }));
            firstRender && (messageBody == "" && messageBodyFixed == "") && setImportDraftPopupVisible(true);
            setFirstRender(false);
          }
        }
      }
    }
  }, [savedDraftList])

  async function handleUnauthorizedTokenError() {
    await logoutUser({
      persistItemsReducer, loginReducer, dispatch,
      LogoutAction, constants, navigate
    });
  }

  useEffect(() => {
    // if token is expired or unauthorized, logout user
    if (worldReducer.errorMessage?.status === 401 || writingTemplatesReducer.errorMessage?.status === 401 ||
      sponsorshipsDataReducer?.errorMessage?.status === 401 ||
      persistItemsReducer.errorMessage?.status === 401 || draftDetailsReducer?.errorMessage?.status === 401 ||
      saveDraftReducer.errorMessage?.status === 401 || connectFeedReducer?.errorMessage?.status === 401) {
      handleUnauthorizedTokenError()
      return
    }
  }, [worldReducer?.errorMessage?.status, writingTemplatesReducer?.errorMessage?.status,
  sponsorshipsDataReducer?.errorMessage?.status, persistItemsReducer?.errorMessage?.status,
  draftDetailsReducer?.errorMessage?.status, saveDraftReducer?.errorMessage?.status,
  connectFeedReducer?.errorMessage?.status]);

  const mutipleChildViewMobile = (recipientsList && recipientsList.length > 1) ? (
    <Multiplechildstyle>
      <Multiplechildtextstyle>
        +
        {(recipientsList.length - 1)}
      </Multiplechildtextstyle>
    </Multiplechildstyle>
  ) : null;

  const mutipleChildView = (recipientsList) ? (
    <Multiplechildstyle>
      <Multiplechildtextstyle>
        +
        {(recipientsList.length - 3)}
      </Multiplechildtextstyle>
    </Multiplechildstyle>
  ) : null;

  const addChildViewMobile = (recipientsList && recipientsList.length > 0) ? (
    <ConnectChildNameContainer>
      <ConnectChildImg src={childImageURL ? childImageURL : PLACEHOLDER} alt="" />
      <ConnectChildName>{childFirstName}</ConnectChildName>
      {(recipientsList[0]?.sensitivity == 1 || recipientsList[0]?.sensitivity == 2) ?
        <img src={SENSITIVEAREAICON} style={styles.sensitiveiconstyle} alt="" /> : null}
      {mutipleChildViewMobile}
    </ConnectChildNameContainer>
  ) : null;

  const addChildView = (recipientsList && recipientsList.length > 0 && recipientsList.length < 4) ?
    (recipientsList.map((item, index) => {
      return (<ConnectChildNameContainer key={index}>
        <ConnectChildImg src={item.childImageURL ? item.childImageURL : PLACEHOLDER} alt="" />
        {(item?.sensitivity == 1 || item?.sensitivity == 2) ?
          <img src={SENSITIVEAREAICON} style={styles.sensitiveiconstyle} alt="" /> : null}
        <ConnectChildName>{item.childFirstName}</ConnectChildName>
      </ConnectChildNameContainer>)
    })
    ) : (recipientsList && recipientsList.slice(0, 3).map((item, index) => {
      return (<ConnectChildNameContainer key={index}>
        <ConnectChildImg src={item.childImageURL ? item.childImageURL : PLACEHOLDER} alt="" />
        <ConnectChildName>{item.childFirstName}</ConnectChildName>
        {(item?.sensitivity == 1 || item?.sensitivity == 2) ?
          <img src={SENSITIVEAREAICON} style={styles.sensitiveiconstyle} alt="" /> : null}
        {index == "2" ? mutipleChildView : null}
      </ConnectChildNameContainer>)
    })
    );

  const addBibleVerse = (data) => {
    setSelectedBibleVerse(data);
    setBibleModalVisibility(!isBibleModalVisible);
    setIsEdited(true);
  };

  const setTemplateModalVisibility = () => {
    setTemplateModalVisible(!isTemplateModalVisible);
    gaEvent("ChooseATemplate", persistItemsReducer);
  };

  const addTemplateHandler = async (data) => {
    setTempOcationData(data);
    if (messageBody && messageBodyFixed !== null && messageBody !== messageBodyFixed) {
      setTimeout(() => { setIsWipeoutVisible(true); }, 500);
    }else if (messageSubject && messageSubjectFixed && messageSubject !== messageSubjectFixed) {
      setTimeout(() => { setIsWipeoutVisible(true); }, 500);
    } 
    else if (data && data.artifactCode && data.artifactCode === "OCN_NONE" && messageBody) {
      setTimeout(() => { setIsWipeoutVisible(true); }, 500);
    } else if (data && data.body) {
      let updated = data.body.replace(/(?:\r\n|\r|\n|\\n)/g, "\n\n");
      if (persistItemsReducer?.selectedSOData?.soLanguageCultureCode === AppConstants.FR_FR) {
        updated = formattedTemplateText(data.artifactCode, updated);
      }
      const trimmed = updated.substr(0, charecterLimit);

    // Only update state and dispatch if content has changed
    if (trimmed !== messageBodyFixed || trimmed !== messageBody) {
      setMessageBodyFixed(trimmed);
      setMessageBody(trimmed);
      const param = {
        savedMessageList: trimmed,
      };
      dispatch(Action.saveMessagePersist(param));
    }
      setMessageBodyFixed(updated.substr(0, charecterLimit));
      setMessageBody(updated.substr(0, charecterLimit));
      setTempOcationData(null);
      setSelectedTemplate(data);
      setMessageTitle(recipientsList?.length, data, childFirstName, recipientsList);
      setIsEdited(true);
      
    }
  };

  const onAddRecipients = (childList) => {
    setAddRecipinetModalVisible(false);
    if (childList && childList.length > 0) {
      const recipients = childList.filter((x) => x.isSelected);
      const locallist = [...recipientsList];
      locallist.splice(0);
      if (recipients && recipients.length > 0) {
        locallist.push(...recipients);
      }
      const objIndex = locallist
        .findIndex((obj) => obj.childCode == childValues.childCode);
      if (objIndex > -1 && objIndex < locallist.length && locallist[objIndex]) {
        setChildFirstName(locallist[objIndex]?.childFirstName);
        setChildImageURL(locallist[objIndex]?.childImageURL);
      } else {
        setChildFirstName(locallist[0]?.childFirstName);
        setChildImageURL(locallist[0]?.childImageURL);
      }
      setMessageTitle(locallist?.length, selectedTemplate, locallist[0]?.childFirstName, locallist);
      setRecipientsList(locallist);
      if (locallist?.some((x) => x.sensitivity == 1 || x.sensitivity == 2)) {
        setSensitiveAreaVisible(true);
        setBibleVerseVisible(false);
      } else {
        setBibleVerseVisible(true);
        setSensitiveAreaVisible(false);
      }
      setSensitiveAreaText(locallist);
      setIsEdited(true);
    }
  };

  const onAddAnotherChildClick = () => {
    setAddRecipinetModalVisible(true);
    gaEvent("AddAnotherChild", persistItemsReducer);
  };

  const onAttachImageClick = () => {
    if (isPhotoGuideLineViewed === false) {
      setAttachPhotoWarningModalVisible(true);
      gaEvent("AttachImage", persistItemsReducer);
      setIsPhotoGuideLineViewed(true);
      updatePhotoGudielineViewedState();
    }
  };

  const onCancelAttachImageClick = () => {
    setRemoveAttachmentModalVisible(true);
    gaEvent("CancelAttachImage", persistItemsReducer)
  }

const onUnderstandClickHandler = async (image) => {
  // Max size in KB (10 MB)
  const MAX_SIZE_KB = 10240;

  // Step 1: MIME type check
  if (image.type !== "image/jpeg") {
    setErrorTitle(t("FormatErrorTitle"));
    setErrorMessage(t("FormatErrorDescription"));
    setIsErrorOccured(true);
    setAttachPhotoWarningModalVisible(false);
    return false;
  }

  // Step 2: File size check
  const fSize = image.size / 1024;
  if (fSize >= MAX_SIZE_KB) {
    setErrorTitle(t("SizeErrorTitle"));
    setErrorMessage(t("SizeErrorDescription"));
    setIsErrorOccured(true);
    setAttachPhotoWarningModalVisible(false);
    return false;
  }

  // Step 3: Magic number check (first 3 bytes should be FF D8 FF)
  const isRealJPEG = await new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = (e) => {
      const arr = new Uint8Array(e.target.result).subarray(0, 3);
      const header = arr.join(" ");
      resolve(header === "255 216 255");
    };
    reader.readAsArrayBuffer(image.slice(0, 3));
  });

  if (!isRealJPEG) {
    setErrorTitle(t("FormatErrorTitle"));
    setErrorMessage(t("FormatErrorDescription"));
    setIsErrorOccured(true);
    setAttachPhotoWarningModalVisible(false);
    return false;
  }

  // ✅ Valid JPEG → proceed
  setAttachPhotoWarningModalVisible(false);
  setAttachmentVisible(true);
  setImagePickerResponse(URL.createObjectURL(image));
  setIsEdited(true);

  const reader = new FileReader();
  reader.readAsDataURL(image);
  reader.onload = function () {
    const base64data = reader.result.split(",");
    setImageBase64(base64data[1]);
  };

  return true;
};
  const onDeleteImage = () => {
    setAttachmentVisible(false);
    setImagePickerResponse(null);
    setImageBase64(null);
    setIsEdited(true);
    setRemoveAttachmentModalVisible(false);
    gaEvent("DeleteImage", persistItemsReducer);
  };

  const validateFields = () => {
    setErrorTitle(false);
    setErrorMessage(false);
    if (!messageSubject) {
      setErrorTitle(t("PleaseEnterSubject"));
      setErrorMessage(t("PleaseEnterSubject"));
      setIsErrorOccured(true);
      return false;
    }
    if (!messageBody) {
      setErrorTitle(t("FeedbackEmptyMessageErrorTitle"));
      setErrorMessage(t("FeedbackEmptyMessageErrorDescription"));
      setIsErrorOccured(true);
      return false;
    }
    if(messageBody){
      const {title, error} = validateMessageBody(messageBody, minCharacterLimit, charecterLimit, t);
      if(title && error){
        setErrorTitle(title);
        setErrorMessage(error);
        setIsErrorOccured(true);
        return false;
      }
    }

    return true;
  }

  const onPersonaliseClick = () => {
    isMailSend.current = true
    clearTimeout(timerRef)
    if (recipientsList && recipientsList?.length < 1) {
      setAddRecepientWarning(true);
      return;
    }
    // new code for language - start
    if (
      loginReducer?.getSOConfiguration?.connectScreenLanguageOptions
        ?.multipleLanguagesSupported &&
      selectedLanguage.trim().length === 0
    ) {
      setLanguageWarning(true);
      return;
    }
    if (validateFields()) {
      if (recipientsList && recipientsList.length > 0) {
        let requestBase = null;
        let occationCode = "";
        let bibleVerseCode = "";
        let messageSubjectReq = "";
        if (selectedTemplate) {
          occationCode = selectedTemplate.artifactCode;
        }
        if (selectedBibleVerse && !isSensitiveAreaVisible) {
          bibleVerseCode = selectedBibleVerse.artifactCode;
        }
        let isEdit = false;
        if ((messageBody && messageBodyFixed && messageBody != messageBodyFixed)
          || isEdited) {
          isEdit = true;
        }
        const childcodes = Object.keys(recipientsList).map((k) => recipientsList[k]?.childCode).join(",");
        const childNames = Object.keys(recipientsList).map((k) => recipientsList[k]?.childFirstName).join(",");
        if(occationCode == "OCN_BIRTHDAY" || occationCode == "OCN_CHRISTMAS" || occationCode == "OCN_EASTER"){
          messageSubjectReq = messageSubject.split(" ")[0]+" "+messageSubject.split(" ")[1]+" {childname}!"
        }else{
          messageSubjectReq = messageSubject.split(" ")[0]+" {childname}!"
        }
        if (isSensitiveAreaVisible) {
          requestBase = {
            sponsorID: persistItemsReducer?.sponsorID,
            childCode: childcodes,
            childName: childNames,
            subject: messageSubject,
            messageSubject: messageSubjectReq,
            messageBody: DOMPurify.sanitize(messageBody),
            imageBase64,
            selectedBibleVerseData: null,
            bordersData: writingTemplatesReducer?.getWritingTemplates?.borders,
            artifactID: 0,
            imageURI: imageBase64,
            recipientsList,
            occationCode,
            bibleVerseCode,
            messageBodyOriginal: DOMPurify.sanitize(messageBody),
            isEdit,
          };
        } else {
          let MessageBodyValue = messageBody;
          if (selectedBibleVerse && selectedBibleVerse.artifactCode && selectedBibleVerse.artifactCode != "BV_1") {
            MessageBodyValue = `${messageBody}\n\n${selectedBibleVerse?.title}\n${selectedBibleVerse.body}`;
          }
          requestBase = {
            sponsorID: persistItemsReducer?.sponsorID,
            childCode: childcodes,
            childName: childNames,
            subject: messageSubject,
            messageSubject: messageSubjectReq,
            messageBody: DOMPurify.sanitize(MessageBodyValue),
            imageBase64,
            selectedBibleVerseData: selectedBibleVerse,
            bordersData: writingTemplatesReducer?.getWritingTemplates?.borders,
            artifactID: 0,
            imageURI: imageBase64,
            recipientsList,
            occationCode,
            messageBodyOriginal: DOMPurify.sanitize(messageBody),
            isEdit,
            isDraftMessage,
          };
        }
        if (requestBase) {
          setPreviewData(requestBase)
          setPreviewModalVisible(!isPreviewModalVisible)
        }
      }
    }
    gaEvent("PreviewBtn", persistItemsReducer);
  };

  const templateview = isTemplateVisible ? (
    <Templatestyle>
      <Templateiconstyle>
        <img src={TEMPLATEICON} alt="" />
      </Templateiconstyle>
      <Templatetextstyle style={{ paddingRight: "20px" }}>
        {t("ChooseATemplate")}
      </Templatetextstyle>
      <ArrButton
        isTemplateModalVisible={isTemplateModalVisible}
        onClick={() => setTemplateModalVisibility()}
      />
      <span className="select-template" />
      {shouldRenderGuidelines &&
        connectGuidelines?.map((guideline, index) => {
          const isLastItem = index === connectGuidelines.length - 1;
          return (
            <ConnectGuidelines
              key={guideline.name}
              isLastItem={isLastItem}
              guideline={guideline}
              onViewNext={() => onViewNext(index, guideline.name)}
              onCloseGuideline={() => onCloseGuideline(index)}
            />
          );
        })}
    </Templatestyle>
  ) : null;
  // new code for language - start
  const templateViewSelectLanguage =
    loginReducer?.getSOConfiguration?.connectScreenLanguageOptions
      ?.multipleLanguagesSupported ||
      loginReducer?.getSOConfiguration?.connectScreenLanguageOptions
        ?.supportedLanguages?.length > 0 ? (
      <Templatestyle style={{ width: "100%" }}>
        <Templateiconstyle>
          <img src={SelectLanguage} alt="" />
        </Templateiconstyle>
        <Templatetextstyle style={{ paddingRight: "20px" }}>
          {t("SelectLanguage")}
        </Templatetextstyle>

        <TemplateSelectedLanguageRadioButton>
          {loginReducer?.getSOConfiguration?.connectScreenLanguageOptions?.supportedLanguages?.map((ele) => {
            const soCode = persistItemsReducer?.selectedSOData?.soCode;
            let displayLanguage;

            if (soCode === "AUTO") {
              displayLanguage = ele.languageName === "German" ? "Deutsch" : "Englisch";
            } else if (soCode === "JPNO") {
              displayLanguage = ele.languageName === "Japanese" ? t("Japanese") : "English";
            } else {
              displayLanguage = ele.languageName === "Finnish" ? "suomi" : "englanti";
            }

            return (
              <span
                key={ele.languageName}
                style={{
                  display: "flex",
                  gap: "6px",
                  alignItems: "center",
                  marginLeft: "15px",
                }}
              >
                <input
                  type="radio"
                  name="language"
                  value={ele.languageName}
                  checked={ele.languageName === selectedLanguage}
                  onChange={() => languageHandler(ele.languageName)}
                />
                <span>{displayLanguage}</span>
              </span>
            );
          })}
        </TemplateSelectedLanguageRadioButton>

      </Templatestyle>
    ) : null;

  const addAnotherChildView = (sponsoredChildList && sponsoredChildList.length > 1) ? (
    <AddChildContainer onClick={() => onAddAnotherChildClick()}>
      <span className="add-another-child">
        +
        {" "}
        {t("AddAnotherChild")}
      </span>
    </AddChildContainer>
  ) : null;

  const attachmentview = (isAttachmentVisible) ? (
    <ImagePreviewContainer>
      <img src={imagePickerResponse ? imagePickerResponse : (`data:image/png;base64,${imageBase64}`)} alt="" />

    </ImagePreviewContainer>
  ) : null;

  const bibleverseicon = (isBibleVerseVisible && isConfigBibleVisible) ? (
    <>
    <BibleVerseIcon onClick={() => onBibleVerseClick()}>
      <div className="add-bible-verse"/>
      <img src={BIBLEICON} alt="" />
      <span>
        {selectedBibleVerse && selectedBibleVerse?.title != "None" ? selectedBibleVerse?.title : t("AddBible")}
      </span>
      <button />
    </BibleVerseIcon>
    </>
  ) : null;

  const resetSponsoredList = () => {
    sponsoredChildList?.forEach((childdata) => {
      childdata.isSelected = false;
    });
    recipientsList?.forEach((recipients) => {
      sponsoredChildList?.forEach((childdata) => {
        if (childdata.childCode == recipients.childCode) {
          childdata.isSelected = true;
        }
      });
    });
  };

  const onWipeOutProceedClick = async () => {
    setIsWipeoutVisible(false);
    if (tempOcationData && tempOcationData.body) {
      const updated = tempOcationData.body.replace(/(?:\r\n|\r|\n|\\n)/g, "\n\n");
      setMessageBodyFixed(updated.substr(0, charecterLimit));
      setMessageBody(updated.substr(0, charecterLimit));
      setSelectedTemplate(tempOcationData);

    } else {
      setMessageBodyFixed("");
      setMessageSubject("");
      setMessageBody("");
      setSelectedTemplate(tempOcationData);
    }
    setMessageTitle(recipientsList?.length, tempOcationData, childFirstName);
    setTempOcationData(null);
  };

  const onWipeOutCancelClick = () => {
    setIsWipeoutVisible(false);
  };

  const onAddRecipientModalClose = () => {
    setAddRecipinetModalVisible(false);
    resetSponsoredList();
  };

  const onBibleVerseClick = () => {
    setBibleModalVisibility(!isBibleModalVisible);
    gaEvent("BibleVerse", persistItemsReducer);
  };

  const successModalClose = () => {
    setMessageBodyFixed("");
    setMessageSubject("");
    setMessageBody("");
    setAttachmentVisible(false);
    setImagePickerResponse(null);
    setImageBase64(null);
    let childValues = props?.childValues;
    const objIndex = sponsoredChildList
      .findIndex((obj) => obj.childCode == childValues.childCode);
    setRecipientsList([sponsoredChildList[objIndex]]);
    setMessageTitle(1, null, sponsoredChildList[objIndex]?.childFirstName);
    resetSponsoredList();
    setIsEdited(false);
    setRecipientsListValues();
    setSelectedTemplate(null);
  }

  const onPreviewModalClose = () => {
    isMailSend.current = false
    let debouncedCall = debounce(onSaveDraftClick, 30000);
    debouncedCall();
    setPreviewModalVisible(!isPreviewModalVisible);
  };

  const onSendMailandClose = () => {
    isMailSend.current = true
    setMessageBodyFixed("");
    setMessageBody("");
    setIsEdited(false);
    setRecipientsListValues();
    setPreviewModalVisible(true);
    clearTimeout(timerRef)
    setShowAutoSave(false)
  };

  const PopulateDraftData = async () => {
    if (selectedDraft) {
      setIsDraftMessage(true);
      let selectedtemptemplate = null;
      if (selectedDraft.subject) {
        setTimeout(() => {
          setMessageSubject(selectedDraft.subject);
          setMessageSubjectFixed(selectedDraft.subject);
        }, 2000)
      }
      if (selectedDraft.body) {
        setMessageSubject(selectedDraft.subject);
        setMessageSubjectFixed(selectedDraft.subject);
        setMessageBody(selectedDraft.body?.substr(0, charecterLimit));
        setMessageBodyFixed(selectedDraft.body.substr(0, charecterLimit));
        messageDefaultValue.current = selectedDraft.body
          .substr(0, charecterLimit)
          .toLowerCase();
      }
      if (selectedDraft.base64Image) {
        setImageBase64(selectedDraft.base64Image);
        setAttachmentVisible(true);
      }
      if (selectedDraft.messageTemplateId && templatesData && templatesData.length > 0) {
        const objIndex = templatesData
          .findIndex((draft) => (draft.artifactID
            === selectedDraft.messageTemplateId));
        if (objIndex && objIndex > -1) {
          const index = templatesData
            .findIndex((obj) => obj.isSelected);
          if (index > -1) {
            templatesData[index].isSelected = false;
          }
          templatesData[objIndex].isSelected = true;
          selectedtemptemplate = templatesData[objIndex];
          setSelectedTemplate(templatesData[objIndex]);
        }
      }
      if (selectedDraft.bibleVerseId && bibleData && bibleData.length > 0) {
        const objIndex = bibleData
          .findIndex((draft) => (draft.artifactID
            === selectedDraft.bibleVerseId));
        if (objIndex && objIndex > -1) {
          const index = bibleData
            .findIndex((obj) => obj.isSelected);
          if (index > -1) {
            bibleData[index].isSelected = false;
          }
          bibleData[objIndex].isSelected = true;
          setSelectedBibleVerse(bibleData[objIndex]);
        }
      }
      if (selectedDraft.childCode && selectedDraft.childCode.length > 0
        && sponsoredChildList && sponsoredChildList.length > 0) {
        const recipients = sponsoredChildList
          .filter((item) => selectedDraft.childCode.includes(item.childCode));
        if (recipients && recipients.length > 0) {
          setRecipientsList(recipients);
          const selectedindex = recipients
            .findIndex((obj) => obj.childCode === childValues?.childCode);
          if (selectedindex > -1 && selectedindex < recipients.length
            && recipients[selectedindex]) {
            setChildFirstName(recipients[selectedindex]?.childFirstName);
            setChildImageURL(recipients[selectedindex]?.childImageURL);
          } else {
            setChildFirstName(recipients[0]?.childFirstName);
            setChildImageURL(recipients[0]?.childImageURL);
          }
          if (!selectedDraft.subject) {
          setMessageTitle(recipients?.length, selectedtemptemplate, recipients[0]?.childFirstName, recipients);
          }
          if (recipients?.some((x) => x.sensitivity && x.sensitivity !== "" && parseInt(x.sensitivity) === 1 || parseInt(x.sensitivity) === 2)) {
            setSensitiveAreaVisible(true);
            setBibleVerseVisible(false);
          } else {
            setBibleVerseVisible(true);
            setSensitiveAreaVisible(false);
          }
          setSensitiveAreaText(recipients);
          const objIndex = sponsoredChildList.findIndex((child) => child.isSelected);
          if (objIndex && objIndex > -1) {
            sponsoredChildList[objIndex].isSelected = false;
          }
          sponsoredChildList?.forEach((child) => {
            recipients?.forEach((recipient) => {
              if (child.childCode === recipient.childCode) {
                child.isSelected = true;
              }
            });
          });
        }
      }
    }
  };

  const clearDraft = () => {
    setSelectedDraft(null);
    setSavedDraftList(null);
    apiRepo.connectRepository.deleteDraft();
  };

  const handleUpload = (e) => {
    onUnderstandClickHandler(e.target.files[0]);
    gaEvent("AttachImagePopupUnderstandBtn", persistItemsReducer);
  };

  const onImportDraftClick = () => {
    PopulateDraftData();
    setImportDraftPopupVisible(false);
  };

  const onWriteANewMessageClick = () => {
    setIsDraftMessage(false);
    clearDraft();
    setImportDraftPopupVisible(false);
    if (localStorage.getItem("selectedLang") === null) {
      if (persistItemsReducer?.selectedSOData?.soCode === "AUTO" || persistItemsReducer?.selectedSOData?.soCode === "FINO") {
        setSelectedLanguage("English");
        getWritingTemplates(getLanguageCode("English"), true);
      }
    }
  };

  function focusInput() {
    const textField = document.getElementById("sampleText");
    if (textFocus) {
      textField.blur();
      settextFocus(false)
    } else {
      textField.focus();
      settextFocus(true);
    }
  }

  const handleTipsClick = () => {
    setOpenTips(!openTips)
  }

  const handleFAQsClick = () => {
    setOpenFAQs(!openFAQs)
  }

  const getSensitiveChildFromList = () => {
    const sensitiveAreaChild = recipientsList?.findLast((x) => x.sensitivity === "1");
    return sensitiveAreaChild ? sensitiveAreaChild?.childFirstName : childFirstName;
  }

  const languageHandler = (code) => {
    setSelectedLanguage(code);
    getWritingTemplates(getLanguageCode(code), true);
    localStorage.setItem("selectedLang", code)
  };

  const formatDateToReadable = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    return `${day}${getOrdinalSuffix(day)} of ${month}`;
  };

  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  const formattedDisableDate = formatDateToReadable(eLetterDisableDate);

  const genderMessage = getGenderMessage(genderCode, t);

  const isFarewell = props?.isCelebrationChild;

  useEffect(() => {
    if (isFarewell && templatesData?.length >= 4) {
      setSelectedTemplate(templatesData[3]);
      const bodyText = writingTemplatesReducer?.getWritingTemplates?.occasions?.[3]?.body;
      if (bodyText) {
        const updated = bodyText.replace(/(?:\r\n|\r|\n|\\n)/g, "\n\n");
        setMessageBodyFixed(updated);
        setMessageBody(updated);
      }
    }
  }, [isFarewell, templatesData, writingTemplatesReducer?.getWritingTemplates?.occasions]);

  return (
    <WriteMsgCointainer
      className={`write-a-letter-connect-screen ${disableELetter && "disable-eletter"}`}
    >
      {t("mgsInstructionText") != "mgsInstructionText" ?
        <InstructionArea id="example-collapse-text">
          <img src={OrphanedIndicatorWhite} alt="Orphaned" />
          <div className={isInstructionVisible ? "sensitive-area-container" : "sensitive-area-container-more"} >
            <div>{t("mgsInstructionText")}</div>
          </div>
          <ArrButton2 isInstructionVisible={isInstructionVisible} onClick={() => setIsInstructionVisible(!isInstructionVisible)} />
        </InstructionArea> : ""
      }
      <SensitiveWrapper>
        {templateViewSelectLanguage}
        {isMobile() ?
          <SelectTemplateDiv>
            {templateview}
            {isSensitiveAreaVisible && (recipientsList?.length < 2) && <><SensitiveArea onClick={() => { setIsSensitivePopupVisible(true); setSensitiveAreaCTA(t("IUnderstand")); setShowSensitiveAreaCheckbox(false) }}>
              <img src={RedIndicator} alt="" />
              <span className="sensitive-area">{t("SensitiveArea", { ChildName: selectedChildData?.childFirstName })}</span>
            </SensitiveArea>

            </>}
          </SelectTemplateDiv> : <>
            {templateview}
            {isSensitiveAreaVisible && (recipientsList?.length < 2) && <><SensitiveArea onClick={() => { setIsSensitivePopupVisible(true); setSensitiveAreaCTA(t("IUnderstand")); setShowSensitiveAreaCheckbox(false) }}>
              <img src={RedIndicator} alt="" />
              <span className="sensitive-area">{t("SensitiveArea", { ChildName: selectedChildData?.childFirstName })}</span>
            </SensitiveArea></>}
          </>}
      </SensitiveWrapper>
      {isTemplateModalVisible &&
        <SensitiveAreaText id="example-collapse-text">
          <div className="sensitive-area-container-template">
            <TemplateModal
              setVisibility={() => { setTemplateModalVisibility(); gaEvent("CloseBtnChooseTemplatePopup", persistItemsReducer) }}
              templatesData={templatesData}
              anniversaryNumber={anniversaryNumber}
              addTemplate={addTemplateHandler}
              draftselectedTemplate={selectedTemplate}
              recipientsList={recipientsList}
              isCelebrationChild={props?.isCelebrationChild}
              isDateEqualandAfter={isDateEqualandAfter(eLetterDisableDate)}
            />
          </div>
        </SensitiveAreaText>
      }
      {isFarewell && persistItemsReducer?.selectedSOData?.soCode === "NZLO" && (
        isMobile(750) ? (
          <FarewellContainer>
            <TextWrapper expanded={expanded}>
              <FarewellTitle>
                {t("FareWellTitle", { ChildName, genderMessage, communityName })}
              </FarewellTitle>
              <FarewellDesc>
                {t("FareWellDescription", { ChildName, genderMessage, communityName, eLetterDisableDate: formattedDisableDate, })}
              </FarewellDesc>
            </TextWrapper>
            <ToggleButton onClick={() => setExpanded(!expanded)}>
              <ToggleText expanded={expanded}>
                {expanded ? "See Less" : "See More"}
                <img
                  src={expanded ? ArrowUP : ArrowDown}
                  alt={expanded ? "up arrow" : "down arrow"}
                  style={{ position: "relative", top: expanded ? "2px" : "-2px" }}
                />
              </ToggleText>
            </ToggleButton>
          </FarewellContainer>
        ) : (
          <FarewellContainer>
            <FarewellTitle>
              {t("FareWellTitle", { ChildName, genderMessage, communityName })}
            </FarewellTitle>
            <FarewellDesc>
              {t("FareWellDescription", { ChildName, genderMessage, communityName, eLetterDisableDate: formattedDisableDate, })}
            </FarewellDesc>
          </FarewellContainer>
        )
      )}

      <MessageContainer className={isSensitiveAreaVisible ? "message-container-full" : "message-container-full"}>
        {!(persistItemsReducer?.selectedSOData?.soCode === "NZLO" && isFarewell) && (
          <MessageTopHeader>
            {sponsoredChildList && sponsoredChildList.length > 1
              ? isMobile()
                ? addChildViewMobile
                : addChildView
              : null}
            {addAnotherChildView}
          </MessageTopHeader>
        )}
        <ChildSubject mobsub={sponsoredChildList?.length>1}>
          <input 
              type="text"
              className={recipientsList?.length>1 ? "template-subject-body disable-subject" : "template-subject-body"}
              placeholder={t("MessageSubject")}
              maxLength={subjectCharLimit}
              onChange={handleSubjectChange}
              value={messageSubject}
              readOnly={recipientsList?.length > 1}
            />
        </ChildSubject>
        {sponsoredChildList && sponsoredChildList.length > 1 ? <LineSeparator></LineSeparator> : null}
        {isSensitiveAreaVisible ? (
          <ChildMessageBody>
            <textarea
              ref={textareaRefSensitive}
              className={isSensitiveAreaVisible ? "template-message-body-full" : "template-message-body-full"}
              placeholder={t("WriteAmessage")}
              maxLength={charecterLimit}
              onChange={e => handleMessageChange(e, textareaRefSensitive)}
              value={messageBody}
              defaultValue={messageBody}
              style={{overflow: "hidden", resize: "none"}}
            />
            {attachmentview}
          </ChildMessageBody>
        ) : (
          <ChildMessageBodyFull mobBody={sponsoredChildList?.length > 1}>
            <textarea
              ref={textareaRefFull}
              onClick={focusInput}
              id="sampleText"
              className={isSensitiveAreaVisible ? "template-message-body-full" : "template-message-body-full"}
              placeholder={t("WriteAmessage")}
              maxLength={charecterLimit}
              onChange={e => handleMessageChange(e, textareaRefFull)}
              value={messageBody}
              defaultValue={messageBody}
              style={{overflow: "hidden", resize: "none"}}
            />
            {attachmentview}
          </ChildMessageBodyFull>
        )}
        <ImagePickerContainer isSensitiveAreaVisible>
          <span style={(messageBody?.length < minCharacterLimit) ? { ...styles.countStyle, ...styles.countStyleRed } : styles.countStyle}>
            {t("Characters")} {messageBody?.length || 0} / {charecterLimit} <br />
            {t("MinCharacters")}
          </span>
          <GalleryContainer>
            {!isAttachmentVisible ?
              <>
                <span className="attach-image"/>
                {isPhotoGuideLineViewed === false ?
                  (<>
                  <GalleryIcon onClick={() => onAttachImageClick()}><img src={GALLERYICON} alt="" />{!isMobile(750) ? t("AttachImage") : ""}</GalleryIcon>
                  </>) : isPhotoGuideLineViewed === true ? (
                    <div className="understand-button">
                      <input type="file"
                        id="files"
                        accept="image/jpg, image/jpeg"
                        onChange={handleUpload}
                      />
                      <label htmlFor="files">
                        <img src={GALLERYICON} alt="" /> {!isMobile(750) ? t("AttachImage") : ""}
                      </label>
                    </div>) : null}
              </>
              :
              <>
                <GalleryIcon>{t("Attachment")}</GalleryIcon>
                <DeleteImageIcon onClick={() => onCancelAttachImageClick()}>
                  <img src={imageBase64 ? (`data:image/png;base64,${imageBase64}`) : DELETEIMAGEICON} alt="" />
                </DeleteImageIcon>
              </>
            }
          </GalleryContainer>
        </ImagePickerContainer>

        <AddRecipientsComponent
          isVisible={addRecipinetModalVisible}
          onClose={() => onAddRecipientModalClose()}
          childList={nonPCChildrenList}
          onAddRecipients={onAddRecipients}
          selectedChildData={selectedChildData}
        />
        <WriteAmessagePreview
          isVisible={isPreviewModalVisible}
          onClose={() => onPreviewModalClose()}
          onSendMailandClose={() => onSendMailandClose()}
          previewData={previewData}
          recipientsList={recipientsList}
          successModalClose={successModalClose}
          letterWritingLanguageCode={selectedLanguage ? getLanguageCode(selectedLanguage) : ""} // new code for language
          selectedTemplate={selectedTemplate}
          childFirstName={childFirstName}
          childImageURL={childImageURL}
          selectedChildData={selectedChildData}
          disable={false}
          isCelebrationChild={props?.isCelebrationChild}
        />
        <AttachPhotoWarningModalComponent
          isVisible={attachPhotoWarningModalVisible}
          onClose={() => {
            setAttachPhotoWarningModalVisible(false);
            gaEvent("AttachImagePopupCloseBtn", persistItemsReducer)
          }}
          onUnderstandClick={onUnderstandClickHandler}
        />
        <RemoveAttachmentModalComponent
          isVisible={removeAttachmentModalVisible}
          onClose={() => { setRemoveAttachmentModalVisible(false); gaEvent("CancelAttachImagePopupCloseBtn", persistItemsReducer) }}
          onProceedClick={() => onDeleteImage()}
          onCancelClick={() => setRemoveAttachmentModalVisible(false)}
          title={t("RemoveAttachment")}
          textValue={t("RemoveAttachmentConfirmation")}
          onProceedText={t("Yes,remove")}
          onCancelText={t("Cancel")}
        />
        <WipeOutModalComponent
          isVisible={isWipeoutVisible}
          onClose={() => setIsWipeoutVisible(false)}
          onProceedClick={() => onWipeOutProceedClick()}
          onCancelClick={() => onWipeOutCancelClick()}
          title={t("WipeoutTitle")}
          textValue={t("WipeoutDescription")}
          onProceedText={t("Proceed")}
          onCancelText={t("Cancel")}
        />
        <BibleModal
          isVisible={isBibleModalVisible}
          setVisibility={() => onBibleVerseClick()}
          bibleData={bibleData}
          addBibleVerse={addBibleVerse}
        />
        <DraftMessageModalComponent
          isVisible={isSaveDraftPopupVisible}
          onClose={() => setSaveDraftPopupVisible(false)}
          onOkClick={() => { onSaveDraftClick(); (recipientsList && recipientsList?.length > 0) && navigate(`/communityhomeview/${encrypt(selectedChildData?.childCode)}`) }}
          onCancelClick={() => onDiscardClick()}
          okText={t("LabelSave")}
          cancelText={t("Discard")}
          title={t("SaveMessage")}
          description={t("SaveMessageDescription")}
          isImport={false}
        />
        <DraftMessageModalComponent
          isVisible={isImportDraftPopupVisible}
          onClose={() => setImportDraftPopupVisible(false)}
          onOkClick={() => onImportDraftClick()}
          onCancelClick={() => onWriteANewMessageClick()}
          okText={t("DT_WVM_ACC_HEAD_00102_Cont")}
          cancelText={t("WriteANewMessage")}
          title={t("ContinueMessage")}
          description={importMessage}
          isImport
        />
        <SensitiveModalComponent
          isVisible={isSensitivePopupVisible}
          onClose={() => setIsSensitivePopupVisible(false)}
          onOkClick={() => setIsSensitivePopupVisible(false)}
          okText={sensitiveAreaCTA}
          checkText={t("DontShow")}
          description={sensitiveText}
          title={t("SensitiveArea", { ChildName: getSensitiveChildFromList() })}
          showSensitiveAreaCheckbox={showSensitiveAreaCheckbox}
        />
        <FAQs
          isVisible={openFAQs}
          childValues={props?.childValues}
          setVisibility={() => { handleFAQsClick() }}
        />
          
        <TipsForWriting
          isVisible={openTips}
          childValues={props?.childValues}
          setVisibility={() => { handleTipsClick() }}
        />
      
      </MessageContainer>
        
      {showAutoSave && lastUpdateon && <AutoSaveDraft>
        <Templateiconstyle><img src={info} style={{ width: "auto" }} alt="" /></Templateiconstyle>
        <Templatetextstyle>{t("DraftSaved")} {writeMessageDateFormat(
          lastUpdateon,
          persistItemsReducer?.selectedSOData?.soCode
        )}
        </Templatetextstyle>
      </AutoSaveDraft>}
      <SensitiveWrapper bible={true}>
        <TabsWrapperdiv>
          <span className="tips-for-writing"/>
          <WritingTips onClick={() => { handleTipsClick(); gaEvent("WritingTips", persistItemsReducer) }}>
            <Templateiconstyle>
              <img src={pencil} style={{ scale: "1.1" }} alt="" />
            </Templateiconstyle>
            <Templatetextstyle>{t("TipsForWriting")}</Templatetextstyle>
          </WritingTips>

          <FAQ onClick={() => { handleFAQsClick(); gaEvent("FAQs", persistItemsReducer) }}>
            <Templateiconstyle>
              <img src={faq} style={{ scale: "1.4" }} alt="" />
            </Templateiconstyle>
            <Templatetextstyle>{t("FAQs")}</Templatetextstyle>
          </FAQ>
        </TabsWrapperdiv>
        {bibleverseicon}
      </SensitiveWrapper>

      <ConnectButtons>
        <span className="preview-send"/>
        <ConnectPreviewButton isSensitiveAreaVisible onClick={() => onPersonaliseClick()}>
          <span>{t("NextStepPersonalise")}</span>
        </ConnectPreviewButton>
        <ConnectSaveButton isSensitiveAreaVisible onClick={() => onSaveDraftClick()}>
          <span>{t("LabelSave")}</span>
        </ConnectSaveButton>
      </ConnectButtons>
      {saveDraftReducer?.loading && !silentDraftLoad && <PageLoaderNew fulldiv position="absolute">
        <div className="spinner--wv-star">
          <div className="double-bounce1"></div>
          <div className="double-bounce2"></div>
        </div>
        <span className="loader_text">{t("Pleasewait")}</span>
      </PageLoaderNew>}
      {
        addRecepientsWarning && <CommonModalPopup
          type="warning"
          show={true}
          title={t("AddRecepientWarningTitle")}
          body={t("AddRecepientWarningMessage")}
          confirm={{ title: t("DT_WVM_CON_HEAD_00044_OkIt"), handler: () => { setAddRecepientWarning(false); setAddRecipinetModalVisible(true) } }}
          cancel={{ title: t("Cancel"), handler: () => { setAddRecepientWarning(false) } }}
          close={{ handler: () => { setAddRecepientWarning(false) } }}
        />
      }
      {languageWarning ? (
        <Error>
          <h2>
            <span className="">{t("SelectLanguage")}</span>
          </h2>
          <p>{t("SelectLanguageWarningMessage")}</p>
          <ErrorClose
            href="javascript:void(0)"
            onClick={() => setLanguageWarning(false)}
          />
        </Error>
      ) : null}
      {showHideConnectModal ?
        <HideConnectModal 
          show={showHideConnectModal}
          onClose={handlePrimaryConnectModal}
          onPrimary={handlePrimaryConnectModal}
          warningText={t("HideConnectSubTitle")}
          primaryText={t("HideConnectButton")}/>: 
        null
      }
    </WriteMsgCointainer>
  )

})

export const isDateEqualandAfter = (date) => {
  try {
    return moment(new Date(date)).isSameOrBefore(moment());
  } catch (error) {
    console.error("Error in isDateEqualandAfter: ", error);
    return false;
  }
};

WriteAmessageView.displayName = "WriteAmessageView";
export default WriteAmessageView;
